import { useState, useEffect, type JSX } from 'react';
import Loader from '@/components/Loader';


import { useGetPlanetSignChangesQuery } from '@/store/api/TransitTable/transitSignApi';
import { useGetPlanetNakshatraTransitQuery } from '@/store/api/TransitTable/planetNakshtraApi';

import PlanetSignTable from '../user/components/TransitTable/PlanetSign';
import PlanetNakshatraTransitTable from '../user/components/TransitTable/PlanetNakshtraTransitTable';

import { useGetPlanetPadaTransitQuery } from '@/store/api/TransitTable/planetPadaApi';
import PlanetPadaTable from '../user/components/TransitTable/PlanetPadaGocharTable';

import { useGetPlanetAstaTransitQuery } from '@/store/api/TransitTable/planetAshtaApi';
import PlanetAstaTable from '../user/components/TransitTable/PlanetAshtaTable';

import { useGetPlanetVakriTransitQuery } from '@/store/api/TransitTable/planetVakriApi';
import PlanetVakriTable from '../user/components/TransitTable/PlanetVakriTable';

export default function TransitsTable(): JSX.Element {
  const {
    data: signData = [],
    isLoading: signLoading,
    isError: signError,
  } = useGetPlanetSignChangesQuery();

  const {
    data: nakshatraData = [],
    isLoading: nakshatraLoading,
    isError: nakshatraError,
  } = useGetPlanetNakshatraTransitQuery();

  const [selectedPlanet, setSelectedPlanet] = useState('');

  const {
    data: padaData = [],
    isLoading: padaLoading,
    isError: padaError,
  } = useGetPlanetPadaTransitQuery();

  const {
    data: astaData = [],
    isLoading: astaLoading,
    isError: astaError,
  } = useGetPlanetAstaTransitQuery();

  const {
    data: vakriData = [],
    isLoading: vakriLoading,
    isError: vakriError,
  } = useGetPlanetVakriTransitQuery();

  const pageLoading =
  signLoading || nakshatraLoading || padaLoading || astaLoading || vakriLoading;


  useEffect(() => {
    if (!selectedPlanet && signData.length > 0) {
      setSelectedPlanet(signData[0]?.planetName ?? '');
    }
  }, [signData, selectedPlanet]);
  if (pageLoading) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Loader />
    </div>
  );
}


  if (signError || nakshatraError || padaError || astaError || vakriError) {
    return <div className="p-6 text-center text-red-500">Failed to load transit data</div>;
  }

  return (
    <section className="rounded-xl p-6 max-w-[1200px] mx-auto space-y-16">
      <PlanetSignTable
        data={signData}
        selectedPlanet={selectedPlanet}
        setSelectedPlanet={setSelectedPlanet}
      />

      <PlanetNakshatraTransitTable
        data={nakshatraData}
        selectedPlanet={selectedPlanet}
        setSelectedPlanet={setSelectedPlanet}
      />

      <PlanetPadaTable
        data={padaData}
        selectedPlanet={selectedPlanet}
        setSelectedPlanet={setSelectedPlanet}
      />

      <PlanetAstaTable
        data={astaData}
        selectedPlanet={selectedPlanet}
        setSelectedPlanet={setSelectedPlanet}
      />

      <PlanetVakriTable
        data={vakriData}
        selectedPlanet={selectedPlanet}
        setSelectedPlanet={setSelectedPlanet}
      />
    </section>
  );
}
